export default {
  '/invoice-loan-list': 'ROLE_INVOICE_LOAN_AS_RECEIVER_LIST',
  '/invoice-loan-gained-list': 'ROLE_INVOICE_PURCHASE_LIST',
  '/loan-update-list': 'ROLE_UPDATE_LIST',
  '/proposal-contract-list': 'ROLE_PROPOSAL_CONTRACT_LIST',
  '/settlements': 'ROLE_SETTLEMENTS_LIST',
  '/settings/contact': 'ROLE_SETTINGS',
  '/settings/password': 'ROLE_SETTINGS',
  '/lead-list': 'ROLE_LEAD_LIST',
  '/lead-block': 'ROLE_LEAD_BLOCKING',
  '/': 'ROLE_USER',
  '/integrations': 'ROLE_INTEGRATIONS',
  '/integrations/:product': 'ROLE_INTEGRATIONS',
  '/integrations/:product/details': 'ROLE_INTEGRATIONS',
  '/integrations/:product/permissions/testing': 'ROLE_INTEGRATIONS',
  '/integrations/:product/permissions/production': 'ROLE_INTEGRATIONS',
  '/integrations/:product/plugins': 'ROLE_INTEGRATIONS',
  '/integration-resources': 'ROLE_INTEGRATION_RESOURCES',
  '/marketing-resources': 'ROLE_MARKETING_RESOURCES',
};
